<template>
    <div>
        <div v-if="!nolabel" class="position-static">
            <b-form-group id="fieldset-datetimepicker" boundary="viewport" v-bind="$attrs" class="position-static">
                <template v-slot:label>{{ labelStr }} <span v-if="isRequired" class="required"></span></template>
                <div v-if="isAllowEdit && !isUpdatable" class="position-static">
                    <b-input-group class="position-static">
                        <b-input-group-prepend class="position-static">
                            <input
                                type="date"
                                v-model="inputModelDate"
                                ref="dateInput"
                                :min="minDate"
                                :max="maxDate"
                                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                placeholder="Select a date"
                                @input="setDate"
                                class="datetext"
                                />
                            <b-form-timepicker
                                boundary="viewport"
                                v-model="inputModelTime"
                                button-only
                                :hour12="false"
                                locale="en"
                                size="sm"
                                class="bg-transparent boundary-datepicker"
                                aria-controls="input-timepicker"
                                @hidden="setTime"
                            ></b-form-timepicker>
                        </b-input-group-prepend>
                        <b-form-input
                            id="example-input"
                            v-model="inputModelTimeStr"
                            type="text"
                            placeholder="No time selected"
                            autocomplete="off"
                            size="sm"
                            v-maska data-maska="##:##"
                        ></b-form-input>
                        <b-form-input
                            id="example-input"
                            v-model="inputModelStr"
                            type="text"
                            placeholder="No time selected"
                            autocomplete="off"
                            size="sm"
                            v-maska data-maska="##/##/#### ##:##"
                            @input="setDateTimeStr"
                            style="display: none"
                        ></b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback id="input-name-live-feedback" :state="state">
                        {{ errorMessage }}
                    </b-form-invalid-feedback>
                </div>
                <div :class="useLabel ? 'input-label-detail' : ''" v-else-if="isUpdatable">
                    <span>{{ inputModel != null && inputModel != "" ? inputModel : "-" | moment('DD-MMM-YYYY HH:mm')}}</span>
                    <span class="float-right"><a v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a></span>
                </div>
                <div v-else>
                    {{ inputModel | moment('DD-MMM-YYYY HH:mm') }}
                </div>
            </b-form-group>
        </div>
        <div v-else class="position-static">
            <div v-if="isAllowEdit && !isUpdatable" class="position-static" style="position:static">
                <b-input-group class="position-static" style="position:static">
                    <b-input-group-prepend class="position-static" style="position:static">
                        <input
                                type="date"
                                v-model="inputModelDate"
                                ref="dateInput"
                                :min="minDate"
                                :max="maxDate"
                                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                placeholder="Select a date"
                                @input="setDate"
                                class="datetext"
                                />
                        <b-form-timepicker
                            boundary="viewport"
                            v-model="inputModelTime"
                            button-only
                            :hour12="false"
                            locale="en"
                            size="sm"
                            class="bg-transparent boundary-datepicker position-static" style="position:static"
                            aria-controls="input-timepicker"
                            @input="setTime"
                        ></b-form-timepicker>
                    </b-input-group-prepend>
                    <b-form-input
                        id="example-input"
                        v-model="inputModelStr"
                        type="text"
                        placeholder="dd/MM/yyyy HH:mm"
                        autocomplete="off"
                        size="sm"
                        v-maska data-maska="##/##/#### ##:##"
                        @input="setDateTimeStr"
                    ></b-form-input>
                </b-input-group>
                <b-form-invalid-feedback id="input-name-live-feedback" :state="state">
                    {{ errorMessage }}
                </b-form-invalid-feedback>
            </div>
            <div :class="useLabel ? 'input-label-detail' : ''" v-else-if="isUpdatable">
                <span>{{ inputModel != null && inputModel != "" ? inputModel : "-" | moment('DD-MMM-YYYY HH:mm')}}</span>
                <span class="float-right"><a v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a></span>
            </div>
            <div v-else>
                {{ inputModel }}
            </div>
        </div>
        <b-popover :show.sync="popoverShow" :target="'popover-button-sync-' + groupId" :title="label" placement="bottomleft">
            <b-input-group class="mb-3 position-static" style="position:static">
                    <b-input-group-prepend class="position-static" style="position:static">
                        <b-form-datepicker
                            boundary="viewport"
                            v-model="inputPopoverModelDate"
                            button-only
                            locale="en-US"
                            aria-controls="input-datepicker"
                            size="sm"
                            class="bg-transparent boundary-datepicker position-static" style="position:static"
                            @input="setPopoverDate"
                            no-flip
                            @shown="onDatePickerShown"
                            @hide="onDatePickerHidden"
                        ></b-form-datepicker>
                        <b-form-timepicker
                            boundary="viewport"
                            v-model="inputPopoverModelTime"
                            button-only
                            :hour12="false"
                            locale="en"
                            size="sm"
                            class="bg-transparent boundary-datepicker position-static" style="position:static"
                            aria-controls="input-timepicker"
                            @input="setPopoverTime"
                        ></b-form-timepicker>
                    </b-input-group-prepend>
                    <b-form-input
                        id="example-input"
                        v-model="inputPopoverModelStr"
                        type="text"
                        placeholder="dd/MM/yyyy HH:mm"
                        autocomplete="off"
                        size="sm"
                        v-maska data-maska="##/##/#### ##:##"
                        @input="setPopoverDateTimeStr"
                    ></b-form-input>
                </b-input-group>
            <div class="popover-action float-right mt-2 mb-1">
                <b-button @click="popoverShow = false" size="sm" class="btn-default-white">Cancel</b-button>
                <b-button @click="setPopoverDateTime" size="sm" class="btn-default ml-2">Save</b-button>
            </div>
        </b-popover>
    </div>
</template>
<style lang="scss" scoped>
    ::v-deep.btn.btn-secondary, ::v-deep.btn.btn-secondary:active, ::v-deep.btn.btn-secondary:hover {
        background-color: transparent !important;
    }
    ::v-deep.form-control:disabled, .form-control[readonly] {
        background-color: transparent !important;
    }
    ::v-deep::placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }

    ::v-deep:-ms-input-placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }

    ::v-deep::-ms-input-placeholder {
        color: #b5b5c3 !important;
        background-color: transparent !important;
    }

    .datetext {
        /* Add any custom styling needed to match Bootstrap-Vue's look and feel */
        display: block;
        width: 100%;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    .datetext:focus {
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
</style>
<script>
import moment from 'moment';
import { vMaska } from 'maska';

export default {
    props: ["model", "id", "errorMessage", "state", "suffix", "prefix", "isEditable", "isUpdatable", "change", "nolabel", "label", "isRequired","min", "max", "nolabel", "returnValue"],
    directives: { maska: vMaska },
    data() {
        return {
            labelStr: this.label,
            inputModel:this.model,
            inputModelDate: '',
            inputModelTime: '',
            inputModelTimeStr: '',
            inputModelStr: null,
            prefixExist: (this.prefix ? true : false),
            suffixExist: (this.suffix ? true : false),
            value:'',
            minDate:this.min,
            maxDate:this.max,
            groupId : "fieldset-datetimepicker-" + this.id,
            inputPopoverModelDate: '',
            inputPopoverModelTime: '',
            inputPopoverModelStr: '',
            popoverInputModel:this.model,
            popoverShow: false,
        }
    }, 
    methods: {
        onDatePickerShown() {
            alert('shown')
        },
        onDatePickerHidden() {
            alert('hide')
        },
        openDatePicker() {
            alert('clicked')
            this.$refs.dateInput.click();
        },
        setDate() {
            console.log(this.inputModelDate);
            let inputModelDate = '1970-01-01';
            if (this.inputModelDate != '') {
                inputModelDate = this.inputModelDate;
            }
            let inputModelTime = '00:00';
            if (this.inputModelTime != '') {
                inputModelTime = this.inputModelTime;
            }
            this.inputModel = inputModelDate + ' ' + inputModelTime;
            let date = new Date(this.inputModel);
            if (date) {
                this.inputModelStr = moment(date).format('DD/MM/YYYY HH:mm');
                this.inputModelTimeStr = moment(date).format('HH:mm');
            }
            this.$emit('update:model', this.inputModel);
            this.$emit('change')
        },
        setTime() {
            let inputModelDate = '1970-01-01';
            if (this.inputModelDate != '') {
                inputModelDate = this.inputModelDate;
            }
            let inputModelTime = '00:00';
            if (this.inputModelTime != '') {
                inputModelTime = this.inputModelTime;
            }
            this.inputModel = inputModelDate + ' ' + inputModelTime;
            let date = new Date(this.inputModel);
            if (date) {
                this.inputModelStr = moment(date).format('DD/MM/YYYY HH:mm');
                this.inputModelTimeStr = moment(date).format('HH:mm');
            }
            this.$emit('update:model', this.inputModel);
            this.$emit('change');
        },
        setLabel(newValue) {
            if (newValue == null) return;
            let date = new Date(newValue);
            if (date != 'Invalid Date') {
                this.inputModelStr = moment(date).format('DD/MM/YYYY HH:mm');
                this.inputModelDate = moment(date).format('YYYY-MM-DD');
                this.inputModelTime = moment(date).format('HH:mm');
                this.inputModelTimeStr = moment(date).format('HH:mm');
            }
            this.inputModel = newValue
        },
        setPopoverDate() {
            let inputModelDate = '1970-01-01';
            if (this.inputPopoverModelDate != '') {
                inputModelDate = this.inputPopoverModelDate;
            }
            console.log(this.inputPopoverModelDate);
            let inputModelTime = '00:00';
            if (this.inputPopoverModelTime != '') {
                inputModelTime = this.inputPopoverModelTime;
            }
            console.log(this.inputPopoverModelTime);
            this.inputPopoverModel = inputModelDate + ' ' + inputModelTime;
            let date = new Date(this.inputPopoverModel);
            if (date) {
                this.inputPopoverModelStr = moment(date).format('DD/MM/YYYY HH:mm');
                this.inputModelTimeStr = moment(date).format('HH:mm');
            }
            //this.$emit('update:model', this.inputPopoverModel);
            //this.$emit('change');
        },
        setPopoverTime() {
            let inputModelDate = '1970-01-01';
            console.log(this.inputPopoverModelDate)
            if (this.inputPopoverModelDate != '') {
                inputModelDate = this.inputPopoverModelDate;
            }
            let inputModelTime = '00:00';
            if (this.inputPopoverModelTime != '') {
                inputModelTime = this.inputPopoverModelTime;
            }
            console.log(this.inputPopoverModelTime);
            this.inputPopoverModel = inputModelDate + ' ' + inputModelTime;
            console.log(this.inputPopoverModel);
            let date = new Date(this.inputPopoverModel);
            if (date) {
                this.inputPopoverModelStr = moment(date).format('DD/MM/YYYY HH:mm');
                this.inputModelTimeStr = moment(date).format('HH:mm');
            }
            //this.$emit('update:model', this.inputPopoverModel);
            //this.$emit('change');
        },
        setPopoverDateTime() {
            this.inputModel = this.inputPopoverModel;
            this.$emit('update:model', this.inputModel);
            this.$emit('change', 'SUBMITTED');
            this.isSubmitted = true;
            this.popoverShow = false;
        },
        onPopoverShow() {
            this.isSubmitted = false;
            this.inputPopoverModelStr = moment(this.inputModel).format('DD/MM/YYYY HH:mm');
            this.inputPopoverModel = this.inputModel;
            this.inputPopoverModelDate = moment(this.inputModel).format('YYYY-MM-DD');
            this.inputPopoverModelTime = moment(this.inputModel).format('HH:mm');
            this.inputModelTimeStr = moment(this.inputModel).format('HH:mm');
            this.popoverShow = true;
        },
        setDateTimeStr() {
            if (this.inputModelStr != null && this.inputModelStr != '') {
                if (this.inputModelStr.length >= 16) {
                    var dateTimeParts = this.inputModelStr.split(" ");
                    var dateParts = dateTimeParts[0].split("/");
                    var timeParts = dateTimeParts[1].split(":");
                    let date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1]); 
                    
                    if (date != 'Invalid Date') {
                        this.inputModelDate = moment(date).format('YYYY-MM-DD');
                        this.inputModelTime = moment(date).format('HH:mm');
                        this.inputModel = moment(date).format('YYYY-MM-DD HH:mm');
                        this.$emit('update:model', this.inputModel);
                        this.$emit('change');
                    } else {
                        this.inputModelStr = 'Invalid Date';
                    }
                }
            }
        },
        setPopoverDateTimeStr() {
            console.log(this.inputPopoverModelStr);
            if (this.inputPopoverModelStr != null && this.inputPopoverModelStr != '') {
                if (this.inputPopoverModelStr.length >= 16) {
                    var dateTimeParts = this.inputPopoverModelStr.split(" ");
                    var dateParts = dateTimeParts[0].split("/");
                    var timeParts = dateTimeParts[1].split(":");
                    let date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1]); 
                    
                    if (date != 'Invalid Date') {
                        this.inputPopoverModelDate = moment(date).format('YYYY-MM-DD');
                        this.inputPopoverModelTime = moment(date).format('HH:mm');
                        this.inputPopoverModel = moment(date).format('YYYY-MM-DD HH:mm');
                    } else {
                        this.inputPopoverModelStr = 'Invalid Date';
                    }
                }
            }
        }
    },
    mounted() {
        this.setLabel(this.model);
    },
    computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        },
        useLabel() {
            if (this.nolabel != null && this.nolabel != undefined && this.nolabel != '') {
                if (this.nolabel) return false;
            }
            return true;
        }
    },
    watch: {
        model(newValue) {
            let date = new Date(newValue);
            if (date != 'Invalid Date') {
                this.inputModelStr = moment(date).format('DD/MM/YYYY HH:mm');
                this.inputModelDate = moment(date).format('YYYY-MM-DD');
                this.inputModelTime = moment(date).format('HH:mm');
                this.inputModelTimeStr = moment(date).format('HH:mm');
            }
            this.inputModel = newValue
        },
        returnValue(newValue, oldValue) {
            if (this.isUpdatable && this.isSubmitted) {
                if (newValue) {
                    this.popoverShow = false;
                    this.isSubmitted = false;
                }
            }
        }
        
    }
}
</script>
<style scoped>
.input-group-text {
    font-size: 0.7rem !important;
}
</style>